import { Box, Text, VStack } from '@chakra-ui/react'
import { useChartTheme } from '../../../hooks/useChartTheme'

interface CustomTooltipProps {
  active?: boolean
  payload?: Array<{ name: string; value: number; color: string }>
  label?: string
  formatter?: (value: number, name: string) => string
}

export default function CustomTooltip({ active, payload, label, formatter }: CustomTooltipProps) {
  const { tooltip } = useChartTheme()

  if (!active || !payload?.length) return null

  return (
    <Box
      bg={tooltip.bg}
      border="1px solid"
      borderColor={tooltip.border}
      borderRadius="xl"
      px={4}
      py={3}
      boxShadow="lg"
    >
      <Text fontSize="xs" fontWeight="600" color={tooltip.label} mb={2}>
        {label}
      </Text>
      <VStack gap={1} alignItems="flex-start">
        {payload.map((entry) => (
          <Text key={entry.name} fontSize="sm" color={tooltip.text}>
            <Box as="span" display="inline-block" w="8px" h="8px" borderRadius="full" bg={entry.color} mr={2} />
            {entry.name}: {formatter ? formatter(entry.value, entry.name) : entry.value.toLocaleString()}
          </Text>
        ))}
      </VStack>
    </Box>
  )
}
